import { IconType } from "react-icons";
import { UserModuleNameTypes } from "./models/userAccess/UserAccess.model";
import {  RiUserSettingsLine } from "react-icons/ri";
import { LuUsers } from "react-icons/lu";

type NavItemTypeWithoutChild = {
    label: string;
    moduleName: string;
    path: string;
    icon: IconType;
    children?: never;
};

type NavItemTypeWithChild = {
    label: string;
    moduleName: string;
    path?: never;
    icon: IconType;
    children?: {
        label: string;
        moduleName: string;
        path: string;
        icon: IconType;
    }[];
};

export type NavItemType = NavItemTypeWithChild | NavItemTypeWithoutChild;

export const ManagementsAdmins: NavItemType[] = [
    {
        label: "User",
        icon: LuUsers,
        moduleName: UserModuleNameTypes.USER,
        path: "user",
      },
      {
        label: "Roles",
        icon: RiUserSettingsLine,
        moduleName: UserModuleNameTypes.ROLES,
        path: "user-role",
      },
];
